module.exports = __webpack_public_path__ + "img/m-logo.264b0787.png";